/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Header_Claimant_DataInputs */

const en_case_header_claimant_data = /** @type {(inputs: Case_Header_Claimant_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant`)
};

const pt_br2_case_header_claimant_data = /** @type {(inputs: Case_Header_Claimant_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerente`)
};

/**
* | output |
* | --- |
* | "Claimant" |
*
* @param {Case_Header_Claimant_DataInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_header_claimant_data = /** @type {((inputs?: Case_Header_Claimant_DataInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Header_Claimant_DataInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_header_claimant_data(inputs)
	return pt_br2_case_header_claimant_data(inputs)
});